const _ = require("lodash");
const permalink = {
  /**
   * Extract minimal data from store
   * @param state
   * @returns {{view, summaryDimensions: ([string]|*), summaryDisplayType: (string|*), mainFilterSelected: (null|*), kpiSelected: (null|*), summaryGainChecked: (boolean|*), filters, summaryKpi: (null|*)}}
   */
  getStateData: state => {
    const data = _.cloneDeep({
      filters: state.filters,
      kpiSelected: state.kpiSelected,
      mainFilterSelected: state.mainFilterSelected,
      //period: state.period,
      view: state.view,
      summaryDimensions: state.summaryDimensions,
      summaryKpi: state.summaryKpi,
      summaryDisplayType: state.summaryDisplayType,
      summaryGainChecked: state.summaryGainChecked
    });

    //remove useless data from data.fitlers
    const filterKeys = Object.keys(data.filters);
    for (let i = 0; i < filterKeys.length; i++) {
      const filterKey = filterKeys[i];
      const item = data.filters[filterKey] || {};
      delete item.data;
    }

    return data;
  },
  /**
   * convert object to url query string
   * @param data
   * @returns {string}
   */
  dataToUrlQuery: data => {
    const dataTostring = JSON.stringify(data);
    return Buffer.from(dataTostring).toString("base64");
  },
  /**
   * Convert url query string to object
   * @param urlParam
   * @returns {{}|any}
   */
  urlQueryToData: urlParam => {
    const dataAsStr = Buffer.from(urlParam, "base64").toString("ascii");
    try {
      return JSON.parse(dataAsStr);
    } catch (e) {
      return {};
    }
  },
  /**
   * Inject filters into query
   * @param {String|Object} query base64|Object query
   * @param {Object} filters {pdc_id:[{id:1234, value:"CARREFOUR PARIS"}]}
   * @param {String} queryFormat base64/object
   * @return {Object} query
   */
  injectFiltersToQuery: (query = {}, filters = {}) => {
    if (typeof query === "string") {
      query = permalink.urlQueryToData(query);
    }
    const queryFilters = query.filters || {};
    const filtersKeys = Object.keys(filters);
    for (let i = 0; i < filtersKeys.length; i++) {
      const filtersKey = filtersKeys[i];
      const filterItem = filters[filtersKey] || [];
      queryFilters[filtersKey] = {
        values: filterItem.map(v => v.id),
        dataSelected: filterItem,
        data: null
      };
    }

    return query;
  }
};

export default permalink;



// WEBPACK FOOTER //
// src/modules/stats/permalink.js